import type { Person } from '../common'
import type { Toast } from 'react-hot-toast'

import cx from 'classnames'

import { Notification } from '../../notifications'
import { generateColor, getInitials, getName } from '../common'

interface Attachment {
  preview: string
}

export interface MessageNotificationProps extends Toast {
  author: Person
  date?: Date
  attachment?: Attachment
  isPatient?: boolean
  children: React.ReactNode
  onOpen?: () => void
  onDismiss: () => void
}

export function MessageNotification ({ author, attachment, isPatient = false, onOpen, ...rest }: MessageNotificationProps): JSX.Element {
  return (
    <Notification
      title={getName(author)}
      isPatient={isPatient}
      left={(
        <div
          className={cx(
            'w-9 h-9 rounded-full flex-shrink-0 flex justify-center items-center font-roboto font-semibold',
            generateColor(author.id)
          )}
        >
          {getInitials(author)}
        </div>
      )}

      right={
        attachment
          ? (
            <img
              src={attachment.preview}
              alt='Attachment preview'
              className='object-cover w-full h-full pointer-events-none'
            />
          )
          : undefined
      }

      onClick={onOpen}
      {...rest}
    />
  )
}
